import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { BillingType } from './useCompanies';

type UpdateCompanyInput = {
  companyId: string;
  name: string;
  finioFirmName?: string | null;
  fcaFirmReferenceNumbers: { id?: string | null; number: string }[];
  isInternal: boolean;
  billingType?: BillingType | null;
  billingAmount?: number | null;
  confirmSharedFeedIdentifiers?: boolean;
};

export const useUpdateCompanyMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, UpdateCompanyInput>({
    mutationFn: (input: UpdateCompanyInput) =>
      api.put(`admin/companies/${input.companyId}`, {
        name: input.name,
        finio_firm_name: input.finioFirmName,
        fca_firm_reference_numbers: input.fcaFirmReferenceNumbers,
        is_internal: input.isInternal,
        billing_type: input.billingType,
        billing_amount: input.billingAmount,
        confirm_shared_feed_identifiers: input.confirmSharedFeedIdentifiers,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies'] });
    },
  });

  const updateCompany = async (input: UpdateCompanyInput) => {
    await mutateAsync(input);
  };

  return {
    updateCompany,
    isLoading,
    error,
  };
};
